import { FormGroup, Label } from "reactstrap";
import __ from "src/utils/Translations";
import React, { FC, useCallback, useMemo, useState } from "react";
import Select from "react-select";
import { debounce } from "lodash";
import useFetchPositionsData from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api/useFetchPositionsData";

interface IPositionsField {
  companyId: string;
  structureId: string;
  value: any;
  onChange: (value: any) => void;
  isEditable: boolean;
}

const PositionsField: FC<IPositionsField> = ({
  companyId,
  structureId,
  value,
  onChange,
  isEditable,
}) => {
  const [inputValue, setInputValue] = useState<string>("");

  const { data, isFetching, hasNextPage, fetchNextPage } =
    useFetchPositionsData(companyId, structureId, inputValue);

  const fetchedPositions = useMemo(
    () =>
      data?.pages.flatMap((page) =>
        page.content.map((pos) => ({
          value: pos.id,
          label: pos.value,
        }))
      ) || [],
    [data]
  );

  const handleInputChange = useCallback(
    debounce((value) => {
      setInputValue(value);
    }, 1000),
    []
  );

  const handleScrollToBottom = () => {
    if (hasNextPage) {
      fetchNextPage();
    }
  };

  return (
    <FormGroup>
      <Label for="position">{__("Stanowisko")}</Label>
      <Select
        id="position"
        value={value}
        onChange={onChange}
        menuPlacement="auto"
        options={fetchedPositions}
        onInputChange={handleInputChange}
        onMenuScrollToBottom={handleScrollToBottom}
        placeholder={__("Wybierz")}
        noOptionsMessage={() => {
          if (isFetching) return __("Ładowanie...");
          return fetchedPositions.length > 0
            ? null
            : __("Brak wyników wyszukiwania");
        }}
        loadingMessage={() => __("Ładowanie...")}
        isClearable
        isLoading={isFetching}
        isDisabled={!isEditable}
      />
    </FormGroup>
  );
};

export default PositionsField;
